import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import {
    CclNavbarSecondaryService,
    CclList,
    CclListColumn,
    CclTemplateResolverService,
    CclListTemplateProviderComponent,
    CclListTemplates,
    CclListColumnSize
} from "certain-common-library";
import { cloneDeep } from "lodash";
import { SessionService } from "../../../../../../modules/shared/services/session-service";
import { FlashMessagesService } from "angular2-flash-messages";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

@Component({
    selector: "app-session-config",
    templateUrl: "./session-config.view.html"
})
export class SessionConfigView implements AfterViewInit, OnInit {
    columns: CclListColumn[];
    selectedFilters = [];
    filtersDropdownSettings = {};
    filters = [];
    sessionConfigObj: any;
    sessionDataConfig: any = {};
    tracksDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "trackName",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    typesDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "sessionType",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    tagsDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "name",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    levelsDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "levelName",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    searchConfig: any = {
        tracks: [],
        types: [],
        tags: [],
        levels: [],
        sessionName: ""
    };
    sessionConfig = {
        eventId: this.sharedService.event.id,
        sessionName: "",
        sessionLabel: "",
        tagIds: [],
        eventTrackIds: [],
        statusIds: [0],
        levelIds: [],
        limit: 10,
        page: 0,
        field: "[name]",
        order: "asc",
        typeIds: [],
        confResponseFilters: []
    };
    sortCase;
    sessions: CclList = <CclList>{};
    listSelection: any = {};
    noSessions: boolean = false;

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private templateResolver: CclTemplateResolverService,
        private cdRef: ChangeDetectorRef,
        private sessionService: SessionService,
        private _flashMessagesService: FlashMessagesService
    ) {
        this.navSecondaryService.sectionLabel = "Data";
        this.filtersDropdownSettings = {
            singleSelection: false,
            idField: "item_id",
            textField: "item_text",
            selectAllText: "All",
            unSelectAllText: "All",
            allowSearchFilter: true,
            isBasicMultiselect: true,
            maxHeight: ""
        };
        this.filters = [
            { item_id: 1, item_text: "Tracks" },
            { item_id: 2, item_text: "Type" },
            { item_id: 3, item_text: "Tags" },
            { item_id: 4, item_text: "Level" }
        ];
        this.selectedFilters = this.filters;
    }

    ngOnInit() {
        this.sessionDataConfig = this.sharedService.dataConfig[this.sharedService.sessionUrl];
        this.sessionDataConfig.selectedList.forEach((element) => {
            this.listSelection[element] = true;
        });
        this.fetchSessions();
    }

    ngAfterViewInit(): void {
        const listTemplates = this.templateResolver.getTemplates(CclListTemplateProviderComponent, [
            CclListTemplates.icon,
            CclListTemplates.name,
            CclListTemplates.data
        ]);
        this.columns = [
            {
                label: "Session Name",
                template: listTemplates[CclListTemplates.name],
                size: CclListColumnSize.full,
                key: "name"
            },
            {
                label: "Session Code",
                template: listTemplates[CclListTemplates.data],
                size: CclListColumnSize.lg,
                key: "sessionCode"
            },
            {
                label: "Status",
                template: listTemplates[CclListTemplates.data],
                size: CclListColumnSize.sm,
                key: "sessionStatus"
            }
        ];

        this.cdRef.detectChanges();
    }

    paginationFilter: any = {
        limit: 10,
        total: 0,
        count: 0,
        offset: 1
    };

    loadFilteredSessions(ev) {
        this.paginationFilter = cloneDeep(ev.pagination);
        let event = cloneDeep(ev);
        this.sessionConfig.order = "asc";
        if (event.sortDescending) {
            this.sessionConfig.order = "desc";
        }
        if (event.sortProperty != null && event.sortProperty != "") {
            this.sessionConfig.field = "[" + event.sortProperty + "]";
        }

        this.fetchSessions();
        this.paginationFilter.offset = 1;
    }

    fetchSessions() {
        const limit = this.paginationFilter.limit;
        const offset = (this.paginationFilter.offset - 1) * limit;
        let page = this.paginationFilter.offset - 1;
        let arrType = [];
        let arrTrack = [];
        let arrTag = [];
        let arrLevel = [];
        if (this.searchConfig.types != undefined && this.searchConfig.types.length > 0) {
            this.searchConfig.types.forEach(function(type) {
                arrType.push(type.id);
            });
        }

        if (this.searchConfig.tracks != undefined && this.searchConfig.tracks.length > 0) {
            this.searchConfig.tracks.forEach(function(track) {
                arrTrack.push(track.id);
            });
        }

        if (this.searchConfig.tags != undefined && this.searchConfig.tags.length > 0) {
            this.searchConfig.tags.forEach(function(tag) {
                arrTag.push(tag.id);
            });
        }

        if (this.searchConfig.levels != undefined && this.searchConfig.levels.length > 0) {
            this.searchConfig.levels.forEach(function(level) {
                arrLevel.push(level.id);
            });
        }

        this.sessionConfig.typeIds = arrType;
        this.sessionConfig.eventTrackIds = arrTrack;
        this.sessionConfig.tagIds = arrTag;
        this.sessionConfig.levelIds = arrLevel;
        this.sessionConfig.sessionName = this.searchConfig.label;
        this.sessionConfig.limit = limit;
        this.sessionConfig.page = page;
        this.sessionService.sessionList(this.sessionConfig).subscribe((data) => {
            if (data.body != null) {
                data.body["pagination"] = {};
                data.body["pagination"]["offset"] = offset / limit + 1;
                data.body["pagination"]["limit"] = limit;
                data.body["pagination"]["total"] = data.body["count"];
                data.body["pagination"]["count"] = 5;
                this.sessions = <CclList>data.body;
                if (this.sessions.data.length > 0) {
                    this.sessions.data.forEach((element) => {
                        if (
                            element["publishAttendeeTypes"] != undefined &&
                            element["publishAttendeeTypes"] != null &&
                            element["publishAttendeeTypes"] != ""
                        ) {
                            element["sessionStatus"] = "Published";
                        }
                    });

                    setTimeout(() => {
                        var chkBoxes = jQuery(".c-list__check-box");
                        var list = this.sessionDataConfig.selectedList;
                        var count = 0;
                        this.sessions.data.forEach((session) => {
                            list.forEach((selectedId) => {
                                if (selectedId == session["id"] + "") {
                                    ++count;
                                }
                            });
                        });
                        if (count == this.sessions.data.length) {
                            chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = true;
                        } else {
                            chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = false;
                        }
                    }, 0);
                } else {
                    this.noSessions = true;
                }
            } else {
                this.noSessions = true;
            }
        });
    }
    clearAllFilter() {
        this.searchConfig.label = "";
        this.searchConfig = {
            tracks: [],
            types: [],
            tags: [],
            levels: [],
            sessionName: this.searchConfig.label
        };
        this.fetchSessions();
    }

    showClearButton() {
        if (
            this.searchConfig.label ||
            this.searchConfig.tracks.length > 0 ||
            this.searchConfig.types.length > 0 ||
            this.searchConfig.tags.length > 0 ||
            this.searchConfig.levels.length > 0
        ) {
            return true;
        } else return false;
    }

    selectSessions(list) {
        setTimeout(() => {
            var chkBoxes = jQuery(".c-list__check-box");
            var count = 0;
            this.sessions.data.forEach((session) => {
                list.forEach((selectedId) => {
                    if (selectedId == session["id"] + "") {
                        ++count;
                    }
                });
            });

            if (count == this.sessions.data.length) {
                chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = true;
            } else {
                chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = false;
            }

            if (list != null && list.length > 10) {
                this._flashMessagesService.show("Cannot select more than 10 sessions for Highlighted.", {
                    cssClass: "alert-danger"
                });
                this.listSelection = {};
                this.sessionDataConfig.selectedList.forEach((element) => {
                    this.listSelection[element] = true;
                });
                chkBoxes[0].firstElementChild.firstElementChild.firstElementChild["checked"] = false;
                return false;
            }

            this.sessionDataConfig.selectedList = list;
        }, 0);
    }

    searchQueryChanged(e) {
        this.searchConfig.label = e;
    }
}
